"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import Image from "next/image";
import { env } from "@/lib/environment";

import "swiper/css";
import "swiper/css/autoplay";

const imgBaseUrl = `${env.NEXT_PUBLIC_CDN_URL}/images/company/team`;

const galleryImages = [
  { src: imgBaseUrl + "/1.CHvTpqkqXNXx.webp", alt: "Pickcel Team" },
  { src: imgBaseUrl + "/2.qbYKyLPdZylX.webp", alt: "Pickcel Team" },
  { src: imgBaseUrl + "/3.EgreywFdihiB.webp", alt: "Pickcel Team" },
  { src: imgBaseUrl + "/gallery-text-1.NPN9vu12PYcc.webp", alt: "Pickcel Team Culture" },
  { src: imgBaseUrl + "/gallery-1.vN4-1WYfwpo_.webp", alt: "Pickcel Team" },
  { src: imgBaseUrl + "/gallery-2.M91ttJtZGSDP.webp", alt: "Pickcel Team" },
  { src: imgBaseUrl + "/4.fqYmWHv5f2Ye.webp", alt: "Pickcel Team" },
  { src: imgBaseUrl + "/5.QOIvBKJZRuNh.webp", alt: "Pickcel Team" },
  { src: imgBaseUrl + "/6.K65Ka2mBDazb.webp", alt: "Pickcel Team" },
  { src: imgBaseUrl + "/7.AewIngGok6aW.webp", alt: "Pickcel Team" },
  { src: imgBaseUrl + "/gallery-3.9ZHhpuBnA3S-.webp", alt: "Pickcel Team" },
  { src: imgBaseUrl + "/gallery-4.h40OyrEihchJ.webp", alt: "Pickcel Team" },
  { src: imgBaseUrl + "/gallery-5.BZ98tb38Y2OL.webp", alt: "Pickcel Team" },
  { src: imgBaseUrl + "/gallery-text-2.NolNf0JkctCt.webp", alt: "Pickcel Team Culture" },
  { src: imgBaseUrl + "/gallery-6.ANXggD3vcm0N.webp", alt: "Pickcel Team" },
  { src: imgBaseUrl + "/8.QvSanA1hll0F.webp", alt: "Pickcel Team" },
  { src: imgBaseUrl + "/9.TOV7YCfsPJ9O.webp", alt: "Pickcel Team" },
  { src: imgBaseUrl + "/10.2hTxrbg1ARXx.webp", alt: "Pickcel Team" },
  { src: imgBaseUrl + "/11.EfoPr4tQXwQs.webp", alt: "Pickcel Team" },
];

interface GalleryCarouselProps {
  className?: string;
}

export default function GalleryCarousel({ className = "" }: GalleryCarouselProps) {
  return (
    <section className={`py-0 overflow-hidden ${className}`}>
      <Swiper
        modules={[Autoplay]}
        slidesPerView={3}
        spaceBetween={30}
        loop={true}
        speed={1000}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          0: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 100,
          },
        }}
        className="gallery-swiper"
      >
        {galleryImages.map((image, index) => (
          <SwiperSlide key={index}>
            <div className="w-full flex items-center justify-center">
              <Image
                src={image.src}
                alt={image.alt}
                title={image.alt}
                width={100}
                height={100}
                loading={index < 6 ? "eager" : "lazy"}
                priority={index < 6}
                className="w-full h-full"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
